// extracted by mini-css-extract-plugin
module.exports = {"blog-card":"BlogCard_blog-card__QVD3K","author-link":"BlogCard_author-link__YL7vw","category-link":"BlogCard_category-link__sA4UX","title":"BlogCard_title__waCE5"};